<template>
  <div style="margin-bottom: 10px">
    <el-cascader
      :options="availableAttachments"
      v-model="valuesOfNodes"
      clearable
      filterable
      placeholder="请选择物品（可搜索）"
      :props="{ expandTrigger: 'hover' }"
    ></el-cascader>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valuesOfNodes: [], 
    };
  },
  created() {},

  props: {
    availableAttachments: Array,
    value: Number,
  },

  watch: {
    valuesOfNodes() {
      this.$emit("input", this.formattedAttachment2Value);
    },
    value() {
      this.valuesOfNodes = this.formattedAttachment2ValuesOfNodes;
    },
  },

  computed: {
    /**
     * 用来返回给外部的
     * 将valuesOfNodes转为value
     */
    formattedAttachment2Value() {
      let value = null;
      if (this.valuesOfNodes.length > 0) {
        value = this.valuesOfNodes[this.valuesOfNodes.length - 1];
      }
      return value;
    },
    /**
     * 用来给内部使用的
     * 将value转为valuesOfNodes
     */
    formattedAttachment2ValuesOfNodes() {
      let nodes = []
      for (let category of this.availableAttachments) {
        if (category.value == this.value) {
          nodes[0] = category.value;
          break;
        }
        if (category.children != null) {
          for (let entry of category.children) {
            if (entry.value == this.value) {
              nodes[0] = category.value;
              nodes[1] = entry.value;
              break;
            }
          }
        }
      }
      return nodes
    },

   
  },

  methods: {
    onClickRemoveBtn() {
      // 向父组件抛出事件
      this.$emit("remove");
    },
  },
};
</script>

<style lang="scss" scoped>
.number-input {
  width: 120px;
}
</style>